import { render, staticRenderFns } from "./DatiClinicoStrumRicoveroEditComponent.vue?vue&type=template&id=1dd8b833&scoped=true"
import script from "./DatiClinicoStrumRicoveroEditComponent.vue?vue&type=script&lang=js"
export * from "./DatiClinicoStrumRicoveroEditComponent.vue?vue&type=script&lang=js"
import style0 from "./DatiClinicoStrumRicoveroEditComponent.vue?vue&type=style&index=0&id=1dd8b833&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd8b833",
  null
  
)

export default component.exports